<template>
  <div class="courseBody">
    <div class="img-box" alt="石室祥云网络课堂"></div>
    <div class="chiocediv">
      <div class="cot">
        <div class="row row1">
          <div class="head">年级</div>
          <div class="content">
            <span
              :class="['hoverStyle',gradeId===item.gradeId?'active':'']"
              v-for="(item,index) in gradeList"
              :key="index"
              @click="clickGrade(item.gradeId)"
            >{{item.gradeName}}</span>
          </div>
        </div>
        <div class="row row2">
          <div class="head">学科</div>
          <div class="content">
            <span
              :class="['hoverStyle',subjectId===item.subjectId?'active':'']"
              @click="clickSubject(item.subjectId)"
              v-for="(item,index) in subjectList"
              :key="index"
              v-show="item.show"
            >{{item.subjectName}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="listDiv">
      <div class="cot">
        <div class="head">
          <span>
            该分类下共有
            <label>{{count}}</label>门课程
          </span>
          <div class="search">
            <input type="text" v-model="searchName" class="name" placeholder="搜索课程" />
            <span class="search_btn" @click="handleSearch()">搜索</span>
          </div>
        </div>
        <div class="coursebox">
          <div class="course-row" v-if="videoList.length>0">
            <div
              class="course-card"
              @click="clickVideo(item)"
              v-for="item in videoList"
              :key="item.dirtreeId"
            >
              <div class="course-cover">
                <div class="wordbg">
                  <p class="enterYear">{{item.entranceYear}}</p>
                  <p
                    class="subject"
                  >{{item.gradeName}}{{item.subjectName}}{{item.term===1?'【上】':'【下】'}}</p>
                </div>
                <img :src="require('../assets/images/'+item.subjectId+'.png')" />
              </div>
              <div class="course-info">
                <p>{{item.courseName}}</p>
              </div>
            </div>
          </div>
          <div v-else>暂无数据</div>
        </div>
        <div class="pageBox">
          <Page
            :total="count"
            show-total
            :page-size="showCount"
            :current="currentPage"
            show-elevator
            class-name="i_page_class1"
            @on-change="changePageNum"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import $ from 'jquery'
export default {
  data() {
    return {
      gradeList: [],
      subjectList: [],
      subjectId: 0,
      gradeId: 0,
      searchName: "", //搜索框内容
      videoList: [], //课程列表
      currentPage: 1, //当前页
      showCount: 12, //每页大小
      count: 0, //该筛选条件下的课程总数
      idGrade: null, //年级id
      idSubject: null, //学科id
      courseName: "", //课程名称
    };
  },
  mounted() {
    let indexGradeId = this.$route.params.gradeId;
    let indexSubjectId = this.$route.params.subjectId;
    if (indexGradeId && indexSubjectId) {

      this.subjectId = indexSubjectId;
      this.gradeId = indexGradeId;
      this.idGrade = indexGradeId;
      this.courseName = "";
      this.idSubject = indexSubjectId; //学科id
      this.getclass();
    } else {
      this.getclass();
    }
    this.getSubject();
  },
  methods: {
    //获取学科列表
    getSubject() {
      this.$post("course/findCourseClassify.action", {}, "externalURL").then(
        (data) => {
          this.gradeList = [
            { gradeName: "全部", gradeId: 0 },
            ...data.sysGrades,
          ];
          this.subjectList = [
            { subjectName: "全部", subjectId: 0 },
            ...data.sysSubjects,
          ];
          for(let o of this.subjectList){
            this.$set(o,'show',true)
          }
        }
      );
    },
    //学科获取
    getgradeSubject(id){
        this.$post(
        "course/subjects/" + id + ".action",
        {},
        "externalURL"
      ).then((data) => {
        console.log(this.subjectList)
        console.log(data)
        for(let o of this.subjectList){
          let flag = false

          for(let v of data){
            if(o.subjectId === 0){
              flag = true
              break
            }
            if(o.subjectId == v.subjectId){
              flag = true
              break
            }
          }
          o.show = flag
        }
      });
    },
    //获取课程列表
    getclass() {
      let parmas = {
        currentPage: this.currentPage, //当前页
        showCount: this.showCount, //单页大小
        gradeId: this.idGrade === 0 ? '' : this.idGrade, //年级Id {可选}
        subjectId: this.idSubject === 0 ? '' : this.idSubject, //科目Id {可选}
        courseName: this.courseName, //课程名 {可选}
      };
      this.$post("course/findCourses.action", parmas, "externalURL").then(
        (data) => {
          this.videoList = data.sysCourses;
          this.count = data.count;
        }
      );
    },
    //分页
    changePageNum(val) {
      this.currentPage = val;
      this.getclass();
    },
    //点击课程
    clickSubject(subjectId) {
      this.subjectId = subjectId;
      this.idSubject = subjectId;
      this.searchName = "";
      this.courseName = "";
      this.currentPage = 1;
      this.getclass();
    },
    //点击年级
    clickGrade(gradeId) {
      this.gradeId = gradeId;
      this.searchName = "";
      this.courseName = "";
      this.idGrade = gradeId;
      this.idSubject = 0
      this.subjectId = 0
      this.currentPage = 1;
      if(gradeId == 0){
        for(let o of this.subjectList){
          o.show = true
        }
      }else{
         this.getgradeSubject(gradeId)
      }
      this.getclass();
    },
    //点击搜索
    handleSearch() {
      this.courseName = this.searchName;
      this.subjectId = 0;
      this.gradeId = 0;
      this.idGrade = null;
      this.idSubject = null;
      this.currentPage = 1;
      this.getclass();
    },
    //点击视频详情
    clickVideo(item) {
      this.$router.push({
        path: "/CoursesDetail",
        query: {
          id: item.dirtreeId,
        },
      });
    },
  },
};
</script>
<style scoped>
.active {
  color: #fff;
  background: linear-gradient(90deg, #398afb, #27aafc);
}
.hoverStyle:not(.active):hover {
  color: #228ddd;
}
.course-row {
  padding: 10px 0px 0px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.course-card {
  width: 23%;
  cursor: pointer;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
  transition: all 0.3s;
  margin: 0px 12px 25px;
}
.course-info {
  padding: 20px 15px 0px;
  padding-bottom: 0;
  background: #fff;
  color: #333;
  height: 90px;
}
.course-cover {
  position: relative;
  height: 178px;
}
.course-cover img {
  width: 100%;
}
.wordbg {
  position: absolute;
  height: 80px;
  width: 220px;
  background: rgba(0, 0, 0, 0.35);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 10px 20px;
  text-align: center;
}
.enterYear {
  font-size: 20px;
  color: white;
}
.subject {
  color: white;
  font-weight: 700;
  font-size: 18px;
}
.course-info p {
  font-size: 15px;
  text-align: center;
}
.listDiv {
  background: #f1f1f1;
  min-height: 660px;
}
.pageBox {
  padding: 30px 0px 50px;
}
.coursebox .course-row .course-card {
  position: relative;
  top: 0;
}
.coursebox .course-row .course-card:hover {
  top: -6px;
  box-shadow: 0 7px 25px 0 rgba(0, 0, 0, 0.17);
  transition: all 0.3s;
}
</style>